<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <div class="max-w-2xl p-8 text-center">
      <img
        src="@/assets/images/biyo_logo.png"
        alt="Biyo Logo"
        class="max-w-xs mr-8"
      />
      <h1>Welcome to Biyo Online Ordering</h1>
      <p>Please access the store using the specific store URL.</p>
      <p>Example: https://order.biyo.co/your-store-name</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
